import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Form } from 'react-final-form';

import CardWrapper, { EDIT_PROJECT_SECTION } from '../card-wrapper/CardWrapper';
import { changeProjectAccessUsers } from '../../../redux/projects/projectsActions';
import AccessUsersForm from './AccessUsersForm';

const AccessUsersSection = () => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();
  const { id } = useParams();

  const editProject = useSelector((state) => state.projects.editProject);

  const accessUsersInitialValues = {
    users: editProject?.users ?? [],
  };

  const handleChangeAccessUsers = useCallback(
    ({ users }) => {
      const userIds = users.map(({ id }) => id);
      dispatch(changeProjectAccessUsers({ id, userIds }));
    },
    [dispatch, id],
  );

  return (
    <CardWrapper label={t('assignedUsers')} sectionType={EDIT_PROJECT_SECTION.ASSIGNED_USERS}>
      <Form
        initialValues={accessUsersInitialValues}
        onSubmit={handleChangeAccessUsers}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => (
          <AccessUsersForm onSubmit={handleSubmit} initialValues={accessUsersInitialValues} />
        )}
      />
    </CardWrapper>
  );
};

export default AccessUsersSection;
